import { subtypeBySystem, subtypes } from "@/lib/iwin";

// Approximate sightlines/depths for drafting; verify against the current YKK AP technical catalogue.
export const YKK_CATALOGUE = {
  "YKK AP IWIN-S Fixed": { frame: 50, mullion: 50, sash: 50, depth: 60, kind: "fixed" },
  "YKK AP IWIN-S Casement": { frame: 50, mullion: 60, sash: 55, depth: 60, kind: "casement" },
  "YKK AP IWIN-S Casement (Tilt & Turn)": { frame: 55, mullion: 65, sash: 60, depth: 70, kind: "casement" },
  "YKK AP IWIN-S Top Hung": { frame: 50, mullion: 60, sash: 55, depth: 60, kind: "casement" },
  "YKK AP IWIN-S Sliding": { frame: 45, mullion: 50, sash: 60, depth: 75, kind: "sliding" },
  "YKK AP IWIN-S Slim Sliding": { frame: 35, mullion: 40, sash: 30, depth: 80, kind: "sliding" },
  "YKK AP IWIN-S Sliding Door": { frame: 50, mullion: 60, sash: 75, depth: 100, kind: "sliding" },
  "YKK AP IWIN-S Casement Door": { frame: 60, mullion: 70, sash: 90, depth: 70, kind: "door" },
  "YKK AP IWIN-S": { frame: 50, mullion: 50, sash: 50, depth: 60, kind: "casement" },
  "YKK AP IWIN-E Sliding": { frame: 45, mullion: 50, sash: 55, depth: 65, kind: "sliding" },
  "YKK AP IWIN-E Casement": { frame: 45, mullion: 55, sash: 50, depth: 50, kind: "casement" },
  "YKK AP IWIN-E Louver": { frame: 40, mullion: 40, sash: 40, depth: 50, kind: "fixed" },
  "YKK AP YES 45 TU Storefront": { frame: 45, mullion: 45, sash: 45, depth: 114, kind: "fixed" },
  "YKK AP YES 60 Storefront": { frame: 51, mullion: 51, sash: 51, depth: 152, kind: "fixed" },
  "YKK AP 35D Entrance Door": { frame: 45, mullion: 45, sash: 89, depth: 45, kind: "door" },
  "YKK AP 50D Entrance Door": { frame: 45, mullion: 45, sash: 127, depth: 45, kind: "door" },
};

let userSeries = [];
export const setUserSeries = (list) => { userSeries = list; };
export const getUserSeries = () => userSeries;

export const catalogueFor = (name) => {
  const key = (name || "").trim();
  const u = userSeries.find((s) => s.series === key);
  if (u) return { ...u, user: true };
  const s = subtypeBySystem(key);
  if (s) return { frame: s.frame, mullion: s.mullion, sash: s.sash, depth: s.depth, kind: s.kind === "door" ? "door" : s.kind, codes: {}, user: false, iwin: true };
  const b = YKK_CATALOGUE[key];
  return b ? { ...b, codes: {}, user: false } : undefined;
};

export const allSeriesNames = () => [...new Set([...userSeries.map((s) => s.series), ...subtypes().map((s) => s.system), ...Object.keys(YKK_CATALOGUE)])];
export const userSeriesForTypology = (t) => userSeries.find((s) => s.typologies?.includes(t));

export function applySeries(item) {
  const c = catalogueFor(item.profile_system);
  if (!c) return item;
  const v = (x, d) => (x > 0 ? x : d);
  return { ...item, frame_width: v(c.frame, item.frame_width), mullion_width: v(c.mullion, item.mullion_width), sash_width: v(c.sash, item.sash_width), frame_depth: v(c.depth, item.frame_depth) };
}

const CODE_FOR = [[/sill/i, ["sill", "frame"]], [/frame/i, ["frame"]], [/mullion/i, ["mullion"]], [/transom/i, ["transom", "mullion"]], [/door leaf/i, ["door_leaf", "sash"]], [/sash/i, ["sash"]], [/bead/i, ["bead"]], [/interlock/i, ["interlock"]]];
export function profileCode(item, memberName) {
  const codes = catalogueFor(item.profile_system)?.codes || {};
  const keys = CODE_FOR.find(([re]) => re.test(memberName))?.[1] || [];
  return keys.map((k) => codes[k]).find(Boolean) || "";
}
